import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    {
      name: t('comparison.row1.name'),
      org: t('comparison.high'),
      search: t('comparison.high'),
      compare: t('comparison.high'),
      best: t('comparison.row1.best'),
      highlight: true,
    },
    {
      name: t('comparison.row2.name'),
      org: t('comparison.low'),
      search: t('comparison.medium'),
      compare: t('comparison.low'),
      best: t('comparison.row2.best'),
      highlight: false,
    },
    {
      name: t('comparison.row3.name'),
      org: t('comparison.medium'),
      search: t('comparison.high'),
      compare: t('comparison.medium'),
      best: t('comparison.row3.best'),
      highlight: false,
    },
    {
      name: t('comparison.row4.name'),
      org: t('comparison.low'),
      search: t('comparison.medium'),
      compare: t('comparison.low'),
      best: t('comparison.row4.best'),
      highlight: false,
    },
  ];

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">{t('comparison.title')}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('comparison.subtitle')}
          </p>
        </div>

        <div className="mt-10 overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left">
            <thead>
              <tr className="bg-secondary-50">
                <th className="px-4 py-3 text-sm font-semibold text-foreground-900">{t('comparison.method')}</th>
                <th className="px-4 py-3 text-sm font-semibold text-foreground-900">{t('comparison.organization')}</th>
                <th className="px-4 py-3 text-sm font-semibold text-foreground-900">{t('comparison.searchability')}</th>
                <th className="px-4 py-3 text-sm font-semibold text-foreground-900">{t('comparison.compare')}</th>
                <th className="px-4 py-3 text-sm font-semibold text-foreground-900">{t('comparison.bestFor')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={row.highlight ? 'bg-primary-50/60' : 'odd:bg-background-50 even:bg-background-100/50'}>
                  <td className="px-4 py-3 text-sm font-medium text-foreground-900">{row.name}</td>
                  <td className="px-4 py-3 text-sm text-foreground-700">{row.org}</td>
                  <td className="px-4 py-3 text-sm text-foreground-700">{row.search}</td>
                  <td className="px-4 py-3 text-sm text-foreground-700">{row.compare}</td>
                  <td className="px-4 py-3 text-sm text-foreground-700">{row.best}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/article/usfans-spreadsheet-guide"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('comparison.cta')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}